import HtmlInput from 'lib/form/controls/HtmlInput--ckeditor';

export function getSiteControl(control, formOption) {
  if (control.type === 'html')
    return HtmlInput;
  return null;
}

